import { Injectable, inject } from '@angular/core';
import { of, throwError } from 'rxjs';
import {
  AuthAccessTokenDetails,
  LoginAuthWithCredentialsResponse,
  LoginOAuthParams,
  SwapAuthForAccessTokens
} from '../../../models';
import { SwapAccessTokenService } from '../../swap-access-token-service/swap-access-token-service';
import { LoginAuthorizationService } from '../login-remember-me-adapter-service/login-authorization/login-authorization-service';
import { LoginPostWithFingerPrintService } from '../login-remember-me-adapter-service/login-post-with-fingerprint/login-post-with-fingerprint-service';
import {
  isUserNamePasswordRequired,
  returnTransformTokenDetails
} from '../login-remember-me-utils-service/initiate-login-utils';
import { LoginRememberMeErrorUtilService } from '../login-remember-me-utils-service/login-remember-me-error-util.service';
import { LoginRememberMeUtilsService } from '../login-remember-me-utils-service/login-remember-me-utils.service';
import { PostWithCredentialsFacadeService } from './post-with-credentials-facade.service';

@Injectable({
  providedIn: 'root'
})
export class InitiateLoginFacadeHelperService {
  retryCount = 0;

  loginAuthorization = inject(LoginAuthorizationService);
  loginPostWithFingerPrint = inject(LoginPostWithFingerPrintService);
  loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  postWithCredentialsFacade = inject(PostWithCredentialsFacadeService);
  loginRememberMeErrorUtil = inject(LoginRememberMeErrorUtilService);
  swapAccessToken = inject(SwapAccessTokenService);

  processResponse(
    response:
      | LoginAuthWithCredentialsResponse
      | SwapAuthForAccessTokens
      | AuthAccessTokenDetails
      | string
      | boolean,
    loginOAuthParams: LoginOAuthParams,
    appToken = false
  ) {
    if (typeof response === 'boolean') {
      return of(response);
    } else if (typeof response === 'string') {
      return throwError(response);
    } else {
      return this.processResponseHelper(response, loginOAuthParams, appToken);
    }
  }

  processResponseHelper(
    response:
      | LoginAuthWithCredentialsResponse
      | SwapAuthForAccessTokens
      | AuthAccessTokenDetails,
    loginOAuthParams: LoginOAuthParams,
    appToken = false
  ) {
    if (isUserNamePasswordRequired(response, loginOAuthParams)) {
      this.retryCount = 0;
      return of(true);
    } else if ('access_token' in response) {
      if (!appToken) {
        this.loginRememberMeUtils.sendTokenServiceWorker(
          loginOAuthParams.oauthConfig,
          response
        );
      }
      this.retryCount = 0;
      return returnTransformTokenDetails(
        response,
        this.postWithCredentialsFacade
      );
    } else {
      return throwError(response);
    }
  }
}
